/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JivoBot } from '../models/JivoBot';
import type { JivoBotAdd } from '../models/JivoBotAdd';
import type { JivoBotsList } from '../models/JivoBotsList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JivoBotsService {
    /**
     * Get jivo bots
     * @returns JivoBotsList OK
     * @throws ApiError
     */
    public static listJivoBots(): CancelablePromise<JivoBotsList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jivo_bots',
        });
    }
    /**
     * Add jivo bot
     * Add jivo bot in list
     * @param requestBody Add jivo bot
     * @returns JivoBot OK
     * @throws ApiError
     */
    public static jivoBotAdd(
        requestBody?: JivoBotAdd,
    ): CancelablePromise<JivoBot> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jivo_bots',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get jivo bot by id
     * @param id jivo_bot_id
     * @returns JivoBot OK
     * @throws ApiError
     */
    public static getJivoBot(
        id: number,
    ): CancelablePromise<JivoBot> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jivo_bots/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update jivo bot
     * update jivo bot by id
     * @param id jivo_bot_id
     * @param requestBody Update jivo bot data
     * @returns JivoBot OK
     * @throws ApiError
     */
    public static updateJivoBot(
        id: number,
        requestBody?: JivoBotAdd,
    ): CancelablePromise<JivoBot> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/jivo_bots/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
